import React, { useEffect, useState } from "react";
import { browserHistory, Link } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import util from "../util/util";
import Tooltip from "../tooltip/tooltip";

export default function PodDetailCampaigns(props) {
  const tooltipMessage =
    "Only successfully ingested pods<br />can be added to a campaign.";

  const [podId, setPodId] = useState(0);
  const [podStatus, setPodStatus] = useState(1);
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    setPodId(props.podId);
    setPodStatus(props.podStatus);
    setCampaigns(props.campaigns.slice(0, 5));
  }, [props.podId, props.podStatus, props.campaigns]);

  const showAll = () => {
    setCampaigns(props.campaigns);
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-5 col-sm-8">
          <h4 className="page__header">Campaigns</h4>
        </div>
        <div className="col-xs-7 col-sm-4">
          <p className="page__actions">
            <span
              data-tip={podStatus !== 2 ? tooltipMessage : ""}
              data-for="podCampaignAddPodToCampaign"
            >
              <button
                className="btn btn-primary"
                disabled={podStatus !== 2 ? true : ""}
                onClick={
                  podStatus !== 2
                    ? () => {
                        return "";
                      }
                    : () =>
                        browserHistory.push(
                          util.returnCampaignFormUrl(0, podId)
                        )
                }
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                Add to New Campaign
              </button>
            </span>
          </p>
          {podStatus !== 2 && <Tooltip id="podCampaignAddPodToCampaign" />}
        </div>
      </div>

      <hr />

      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <colgroup>
            <col style={{ width: `1%` }}></col>
            <col style={{ width: `69%` }}></col>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `15%` }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>#</th>
              <th>Campaign</th>
              <th>Total Pods</th>
              <th>Date Created</th>
            </tr>
          </thead>
          <tbody>
            {campaigns.length === 0 ? (
              <tr>
                <td>
                  <strong>0</strong>
                </td>
                <td colSpan="3">
                  <em>None</em>
                </td>
              </tr>
            ) : (
              campaigns.map((campaign, index) => {
                return (
                  <tr key={campaign.id}>
                    <td>
                      <strong>{index + 1}</strong>
                    </td>
                    <td>
                      <Link to={util.returnCampaignDetailUrl(campaign.id)}>
                        {campaign.name}
                      </Link>
                    </td>
                    <td>{campaign.pod_count}</td>
                    <td>
                      {moment(campaign.created).format(
                        util.dateFormatHumanLong
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {campaigns &&
      props.campaigns &&
      campaigns.length !== props.campaigns.length ? (
        <p className="text-center">
          <button
            id="pod-detail-campaigns__show-all"
            className="btn btn-default"
            onClick={() => showAll()}
          >
            Show All {props.campaigns.length} Campaigns
          </button>
        </p>
      ) : null}
    </div>
  );
}

PodDetailCampaigns.propTypes = {
  campaigns: PropTypes.array,
  podId: PropTypes.number,
  podStatus: PropTypes.number
};
